import React, { memo, useCallback } from 'react';

import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import {
  hintGroupStyles,
  hintKeyStyles,
  labelStyles,
  rootStyles,
} from './TeamChatSoftLinkifyHint.styles';
import { TeamChatSoftLinkifyHintTestIds } from './TeamChatSoftLinkifyHint.testIds';

// mousedown (not click) + preventDefault keeps the composer's caret/selection intact while
// accepting — a plain click would blur the textarea before the token is inserted.
const TeamChatSoftLinkifyHint = memo(({ label = '', isHidden = false, onAccept }) => {
  const onAcceptMouseDown = useCallback(
    e => {
      e.preventDefault();
      onAccept();
    },
    [onAccept],
  );

  if (isHidden || !label) {
    return null;
  }

  return (
    <Box
      data-testid={TeamChatSoftLinkifyHintTestIds.ROOT}
      sx={rootStyles}
      onMouseDown={onAcceptMouseDown}
    >
      <Typography variant="regular14">Link to</Typography>
      <Typography sx={labelStyles} variant="medium14">
        {label}
      </Typography>
      <Box sx={hintGroupStyles}>
        <Box component="span" sx={hintKeyStyles}>
          Tab
        </Box>
        <Typography color="text.secondary" variant="regular12">
          to link
        </Typography>
        <Box component="span" sx={hintKeyStyles}>
          Esc
        </Box>
        <Typography color="text.secondary" variant="regular12">
          dismiss
        </Typography>
      </Box>
    </Box>
  );
});
TeamChatSoftLinkifyHint.propTypes = {
  onAccept: PropTypes.func.isRequired,
  label: PropTypes.string,
  isHidden: PropTypes.bool,
};

export default TeamChatSoftLinkifyHint;
